import { useState, useContext, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import MDInput from "components/MDInput";
import FormField from "components/FormField";
import { DataContext } from "context/dataContext";
import ErrorText from "components/ErrorText";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import { v4 as uuidv4 } from "uuid";

const AddSessionForm = ({ showAsPopup }) => {
  const params = useParams();

  const { dataState, getSingleProgramApi, addSessionApi } = useContext(DataContext);
  const navigate = useNavigate();
  const location = useLocation();

  // Opening Balance Amount
  const [sessions, setSessions] = useState([]);
  const [audio_file, setAudioFile] = useState(null);
  const [playerfile, setPlayerFile] = useState(null);
  const sessionRef = useRef();

  const [value, setValue] = useState({
    name: "",
    slug: "",
    session_type: "Audio",
    duration: "",
    description: "",
    index: null,
  });

  const [errors, setErrors] = useState({
    name: "",
    slug: "",
    session_type: null,
    duration: "",
    description: "",
  });

  const uuidvNumbers = () => {
    const uuid = uuidv4();
    const uuidFinal = uuid.replace(/\D/g, "").slice(0, 12);
    return Number(uuidFinal);
  };

  const validateForm = () => {
    const newErrors = {
      name: value.name ? "" : "Name is required",
      session_type: value.session_type ? "" : "Session Type is required",
    };

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const convertToSlug = (str) => {
    //replace all special characters | symbols with a space
    str = str.replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, " ").toLowerCase();

    // trim spaces at start and end of string
    str = str.replace(/^\s+|\s+$/gm, "");

    // replace space with dash/hyphen
    str = str.replace(/\s+/g, "-");

    return str;
  };

  const handleName = (e) => {
    setValue({ ...value, name: e.target.value });
  };

  const handleType = (event, newValue) => {
    setValue({ ...value, session_type: newValue });
  };

  const handelDescription = (e) => {
    setValue({ ...value, description: e.target.value });
  };

  const ResetValue = () => {
    setValue({ ...value, name: "" });
    setValue({ ...value, slug: "" });
    setValue({ ...value, description: "" });
    setValue({ ...value, duration: "" });
    setValue({ ...value, session_type: "Audio" });
    setAudioFile(null);
  };

  const handleSubmit = (e) => {
    console.log("value", value);
    e.preventDefault();

    if (validateForm()) {
      var genslug = convertToSlug(value.name);

      setValue({ ...value, slug: genslug });

      if (audio_file && genslug) {
        // updateProgramSessionsApi({
        //   id: params.id,
        //   slug: genslug,
        //   sessions: newsessions,
        // }).then((res) => {
        //   if (res.success) {
        //     if (showAsPopup) {
        //       showAsPopup(false);
        //     }
        //     ResetValue();
        //   } else {
        //     console.log("Something went wrong");
        //   }
        // });
        var session_id = uuidvNumbers();
        const form = new FormData();
        form.append("id", session_id);
        form.append("slug", genslug);
        form.append("name", value.name);
        form.append("description", value.description);
        form.append("type", value.session_type);
        form.append("duration", value.duration);
        form.append("program", params.id);
        form.append("created_on", new Date());
        form.append("file", audio_file);

        addSessionApi({
          form: form,
          program: params.id,
        }).then((res) => {
          if (res.success) {
            if (showAsPopup) {
              showAsPopup(false);
              //window.location.refresh();
              navigate(0);
              //navigate(location.pathname);
              console.log("Session added");
              //window.location.refresh(false);
            }
            ResetValue();
          } else {
            console.log("Something went wrong");
          }
        });

        // uploadProgramSessionAudioApi({
        //   id: params.id,
        //   slug: genslug,
        //   audio: audio_file,
        // }).then((res) => {
        //   if (res.success) {
        //     console.log("Audio Added", res);
        //   } else {
        //     console.log("Something went wrong");
        //   }
        // });
      } else {
        alert("Please add audio file");
      }
    }
  };

  const readFile = (file) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      // The file content is available in event.target.result
      const fileContent = event.target.result;
      console.log("File content:");
      setPlayerFile(fileContent);
      // You can now store this content in your component's state
      // or process it further.
    };

    reader.onerror = (error) => {
      console.error("Error reading file:", error);
    };

    // Choose the appropriate reading method based on the file type and desired output:
    // reader.readAsText(file); // Reads the file as a plain text string
    reader.readAsDataURL(file); // Reads the file as a data URL (useful for images)
    // reader.readAsArrayBuffer(file); // Reads the file as an ArrayBuffer
    // reader.readAsText(file); // Example: reading as text
  };

  const handleAudio = (e) => {
    console.log("file", e.target.files[0]);
    setAudioFile(e.target.files[0]);
    var file = e.target.files[0];
    const audio = document.createElement("audio");
    audio.setAttribute("src", URL.createObjectURL(file));
    audio.addEventListener("loadedmetadata", () => {
      const duration = audio.duration;
      setValue({ ...value, duration: duration });
      // do stuff with the duration
    });
    console.log(file);
    if (file) {
      // Proceed to read the file
      readFile(file);
    }
  };

  return (
    <Card autoComplete="off" sx={{ height: "100%", ...(showAsPopup && { boxShadow: "none" }) }}>
      <MDBox p={3} pb={0}>
        <MDTypography variant="h5">Add a New Session</MDTypography>
      </MDBox>
      <MDBox p={3}>
        <MDBox component="form" pb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={showAsPopup ? 12 : 3}>
              <FormField type="text" label="Name" value={value.name} onChange={handleName} />
              {errors.name && <ErrorText errorName={errors.name} />}
            </Grid>
            <Grid item xs={12} sm={showAsPopup ? 12 : 3}>
              <FormField type="text" disabled label="Slug" value={value.slug} />
            </Grid>
            <Grid item xs={12} sm={showAsPopup ? 12 : 3}>
              <FormField type="text" disabled label="Duration" value={value.duration} />
            </Grid>
            <Grid item xs={12} sm={showAsPopup ? 12 : 3}>
              <MDBox mb={1} ml={0.5} lineHeight={0}>
                <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                  Description&nbsp;&nbsp;
                  <MDTypography variant="caption" color="text">
                    (optional)
                  </MDTypography>
                </MDTypography>
              </MDBox>
              <FormField
                type="text"
                multiline
                rows={1}
                value={value.description}
                onChange={handelDescription}
                label="Enter description here"
              />
              {errors.description && <ErrorText errorName={errors.description} />}
            </Grid>
            <Grid item xs={12} sm={showAsPopup ? 12 : 3}>
              <MDBox mb={2} display="inline-block">
                <MDTypography
                  component="label"
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  textTransform="capitalize"
                >
                  Type
                </MDTypography>
              </MDBox>
              <Autocomplete
                defaultValue="Audio"
                options={["Audio"]}
                //options={["Audio", "Text", "PDF", "Video"]}
                value={value.session_type}
                onChange={handleType}
                renderInput={(params) => <MDInput {...params} variant="standard" />}
              />
            </Grid>
            <Grid item xs={12} sm={showAsPopup ? 12 : 3}>
              <MDInput
                type="file"
                label="Audio File"
                variant="standard"
                fullWidth
                ref={sessionRef}
                onChange={handleAudio}
                accept="audio/*"
              />
            </Grid>
            {playerfile ? (
              <Grid item xs={12} sm={showAsPopup ? 12 : 3}>
                <audio controls>
                  <source src={playerfile} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </MDBox>

        <MDBox mt={2} gap={2} width="100%" display="flex" justifyContent="flex-start">
          <MDButton variant="gradient" color="primary" onClick={handleSubmit}>
            Save Session
          </MDButton>
        </MDBox>
      </MDBox>
    </Card>
  );
};

export default AddSessionForm;
